import produce from 'immer';
import { Localizations } from '../../i18n';
import { getLocalizations } from '../../services';
import { changed } from '../../utils';
import { BookingState } from '../state';
import { LifecycleEvent, SideEffect, SideEffectGenerator, Store } from '../types';
import { bindActions } from 'redux-zero/utils';

export const getTranslationsEffect = (store: Store<BookingState>): SideEffect<BookingState> => {
  const effectActions = bindActions(
    {
      _getTranslationsStart: (state) =>
        produce(state, ({ ux }: BookingState) => {
          ux.loading.getLocalizations = true;
        }),
      _getTranslationsFinish: (state, localizations: Localizations) =>
        produce(state, ({ ux }: BookingState) => {
          ux.loading.getLocalizations = false;
          ux.i18n.locale = state.selection.locale;
          ux.i18n.localizations = localizations;
        }),
    },
    store
  );

  const when = (prev: BookingState, next: BookingState) =>
    !!prev.selection?.locale && changed(prev, next, 'selection', 'locale');

  return {
    runSideEffects: (readOnlyState) => {
      const {
        envConfig,
        selection: { locale },
      } = readOnlyState;

      effectActions._getTranslationsStart();
      getLocalizations(envConfig, locale).then((localizations: Localizations) => {
        effectActions._getTranslationsFinish(localizations);
      });
    },
    when,
    runOn: [
      {
        type: LifecycleEvent.INIT,
        when,
      },
    ],
    name: getTranslationsEffect.name,
  };
};

export const i18nEffects: SideEffectGenerator<BookingState>[] = [getTranslationsEffect];
